import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';

export const authHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(KeycloakService);
  const token = keycloak.getKeycloakInstance().token;
  const isFormDataRequest = req.body instanceof FormData;

  const headers: Record<string, string> = {
    Accept: 'application/json',
  };

  if (!isFormDataRequest) {
    headers['Content-Type'] = 'application/json';
  }

  if (
    (req.url.includes('/off_highway/dashboard/totalOpportunity/cagr') ||
      req.url.includes('/off_highway/dashboard/totalOpportunity/validate') ||
      req.url.includes('/spriced/platform') ||
      req.url.includes('/spriced/auth/getEntityPermissions')) &&
    token
  ) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const cloned = req.clone({
    setHeaders: headers,
  });

  return next(cloned);
};
